import { service } from './app.service';
// TODO use interfaces rather than models
import CartItemModel from '@/models/CartItemModel';
import CartOptionModel from '@/models/CartOptionModel';
import CartOptionChoiceModel from '@/models/CartOptionChoiceModel';
import ItemModel from '@/models/ItemModel';
import { flatMapDeep, flatMap, map, merge, clone, cloneDeep, concat, compact, forEach, findIndex, find, reduce, filter, includes, sortBy, reverse, take, } from 'lodash';
import MasterOptionExceptionModel from '@/models/MasterOptionExceptionModel';
import OptionExceptionModel from '@/models/OptionExceptionModel';
import { MENU_OPTION_EXCEPTIONS, CART } from '@/stores/defs';
import masterStore from '@/stores/index';
import orderService from '@Service/order.service';
import recentOrderService from '@Service/recent.orders.service';
var MARK_REMOVAL_KEY = '__mark_removal';
var cartService = {
    // TODO use interface in place of ItemModel
    convertToCartItem: function (item, menu) {
        item['hydrationStrategy'] = 'hydrate';
        var itemModel = new ItemModel(item);
        var menuItem = menu[itemModel.id];
        if (!menuItem) {
            return null;
        }
        var cartItem = new CartItemModel(menuItem);
        return cartItem;
    },
    prepareItem: function (item) {
        var cartItem = new CartItemModel(item);
        cartItem.options = map(cartItem.options, function (option) {
            var exceptions = masterStore.getters[MENU_OPTION_EXCEPTIONS.GET_FOR_ITEM](item.id);
            if (!exceptions) {
                return option;
            }
            var exceptionId = exceptions && exceptions.id;
            var exceptionChoiceId = null;
            for (var cartItemOption in cartItem.options) {
                if (cartItem.options[cartItemOption].id === exceptionId) {
                    var optionChoices = cartItem.options[cartItemOption].choices;
                    var optionChoice = find(optionChoices, function (optionChoice) {
                        if (optionChoice.parentId === exceptionId) {
                            return true;
                        }
                    });
                    exceptionChoiceId = optionChoice.id;
                }
            }
            var optionId = option.id;
            if (option.required) {
                return option;
            }
            if (Object.keys(exceptions.options).length > 1) {
                return option;
            }
            option.choices = map(option.choices, function (choice) {
                /**
                 * We removed code that used to bail early if userSet was true or if includedQuantity was truthy
                 * and selected was false. We need the exceptions to be merged in.
                 */
                if (choice.hasException && exceptionChoiceId) {
                    var optionExceptions = exceptions.options[optionId];
                    var key = exceptionChoiceId + "-" + choice.id;
                    var choiceExceptions = optionExceptions.choices;
                    var choiceOverride = choiceExceptions[key];
                    if (typeof choiceOverride === 'undefined') {
                        return choice;
                    }
                    choiceOverride.selected = choice.selected;
                    /**
                     * We are now merging choice.id, __mc, and quantity back on top of the the defaults so that
                     * we preserve those. __mc is needed because if that gets overwritten with "DefaultChoiceModel"
                     * then the choice will get filtered out down the line. Choice Id is needed because for some
                     * reason the choices from the exception have screwed up ids so we need to re-use the original one.
                     * Lastly the quantity is needed because we need the selected quantity not the default quantity.
                     *
                     * Also we used to hard-code userSet to true but we should just respect the choice.userSet property. We
                     * don't need to add it into this merge because userSet doesn't exist on choiceOverride (an instance of DefaultChoiceModel)
                     */
                    var mergedChoice = merge(choice, choiceOverride, {
                        id: choice.id,
                        __mc: choice.__mc,
                        quantity: choice.quantity
                    });
                    return mergedChoice;
                }
                return choice;
            });
            option.choices = compact(option.choices);
            return option;
        });
        return cartItem;
    },
    prepareOption: function (option) {
        var cartOption = new CartOptionModel(option);
        // TODO this should not check for is divisible
        // this was only implemented to get preselected choices working
        if (!option.isDivisible) {
            forEach(option.choices, function (choice) {
                var isMutable = choice.mutableQuantity;
                if (choice.quantity !== 0 && isMutable) {
                    var cartChoice = cartService.prepareChoice(choice);
                    cartChoice.quantity = 0;
                    cartOption.addChoice(cartChoice);
                }
            });
        }
        return cartOption;
    },
    prepareChoice: function (choice) {
        var cartChoice = new CartOptionChoiceModel(choice);
        cartChoice.selected = true;
        return cartChoice;
    },
    prepareOptionException: function (exception) {
        var optionException = new OptionExceptionModel(exception);
        return optionException;
    },
    prepareMasterOptionException: function (exception) {
        var masterOptionException = new MasterOptionExceptionModel(exception);
        return masterOptionException;
    },
    addChoiceToOption: function (option, choice) {
        var cartChoice = cartService.prepareChoice(choice);
        option = option.addChoice(cartChoice);
        return option;
    },
    findChoiceInOption: function (option, choice) {
        if (!option) {
            return null;
        }
        return option.findChoice(choice);
    },
    checkForChoice: function (option, choice) {
        var optionChoice = null;
        if (option.choices.length > 0) {
            optionChoice = find(option.choices, function (optionChoice) {
                return optionChoice.id === choice.id;
            });
        }
        if (!optionChoice) {
            cartService.addChoiceToOption(option, choice);
        }
        optionChoice = option.findChoice(choice);
        return optionChoice;
    },
    setChoiceQuantityForOption: function (option, choice, quantity) {
        var optionChoice = cartService.checkForChoice(option, choice);
        optionChoice.setQuantity(quantity);
        var included = (optionChoice.includedQuantity > 0);
        if (optionChoice.quantity <= 0 && !included) {
            option.removeChoice(optionChoice);
        }
        return option;
    },
    setSiblingForChoice: function (option, choice, siblingId) {
        var optionChoice = cartService.checkForChoice(option, choice);
        optionChoice.setSibling(siblingId);
        return option;
    },
    removeCartChoiceFromOption: function (option, choice) {
        option.removeChoice(choice);
        return option;
    },
    updateChoiceForOption: function (option, choice) {
        option.updateChoice(choice);
        return option;
    },
    // TODO might be good to abstract map types
    allOptionsFromMap: function (options) {
        var all = [];
        forEach(options, function (option) {
            all.push(option);
        });
        return all;
    },
    getItemIndex: function (items, _item) {
        var hash = _item.hash();
        var itemIndex = findIndex(items, function (item) {
            return item.hash() === hash;
        });
        return itemIndex;
    },
    indexItems: function (cartItems) {
        var indexedItems = forEach(cartItems, function (cartItem, index) {
            if (typeof cartItem !== 'string') {
                cartItem.index = index;
            }
        });
        return indexedItems;
    },
    findMatches: function (cartItems, compareItems, ignoreQuantity) {
        if (ignoreQuantity === void 0) { ignoreQuantity = false; }
        var indices = [];
        var ids = flatMap(compareItems, 'id');
        var matchingItems = filter(cartItems, function (cartItem) {
            if (includes(ids, cartItem.id)) {
                return true;
            }
            return false;
        });
        forEach(matchingItems, function (matchedItem) {
            var quantity = matchedItem.quantity;
            if (!ignoreQuantity) {
                for (var i = 0; i < quantity; i++) {
                    indices.push(matchedItem.index);
                }
            }
            else {
                indices.push(matchedItem.index);
            }
        });
        return indices;
    },
    findFirstMatchIndex: function (cartItems, item) {
        var index = findIndex(cartItems, function (cartItem) {
            var matchingId = (cartItem.id === item.id);
            if (item.options.length === 0) {
                return (matchingId);
            }
            // TODO implement options match
        });
        return index;
    },
    // TODO possible call to configure maximum amount of a particular item per order.
    getItemMax: function (item) {
        return 100;
    },
    sortItemsByPrice: function (cartItems, indices) {
        var items = cartItems;
        if (indices) {
            items = filter(cartItems, function (item) {
                var index = item.index;
                if (includes(indices, index)) {
                    return true;
                }
                return false;
            });
        }
        for (var i = 0; i < items.length; i++) {
            var item = items[i];
            var quantity = +(item.quantity);
            while (quantity > 1) {
                quantity--;
                var itemClone = clone(item);
                itemClone.quantity = 1;
                items.push(itemClone);
            }
        }
        var sorted = sortBy(items, function (item) {
            return item.getSingleItemTotal();
        });
        return sorted;
    },
    findMostExpensive: function (cartItems, indices) {
        var index = 0;
        var price = cartService.sortItemsByPrice(cartItems, indices);
        var lastIndex = price.length - 1;
        index = price[lastIndex]['index'];
        return index;
    },
    sortMostExpensiveItems: function (cartItems) {
        var sorted = sortBy(cartItems, function (item) {
            return -(item.getSingleItemTotal());
        });
        return sorted;
    },
    findLeastExpensive: function (cartItems, indices) {
        var index = 0;
        var price = cartService.sortItemsByPrice(cartItems, indices);
        index = price[0]['index'];
        return index;
    },
    findMostExpensiveRunnerup: function (cartItems, indices) {
        var index = 0;
        var price = cartService.sortItemsByPrice(cartItems, indices);
        var lastIndex = price.length - 1;
        var runnerUp = (lastIndex > 0) ? lastIndex - 1 : lastIndex;
        index = price[runnerUp]['index'];
        return index;
    },
    findMostExpensiveItems: function (cartItems, indices, amount) {
        var items = cartService.sortItemsByPrice(cartItems, indices);
        var mostExpensiveItems = reverse(items);
        if (amount === 0) {
            amount = mostExpensiveItems.length;
        }
        return take(mostExpensiveItems, amount);
    },
    findNextItemWithoutDiscount: function (cartItems, indices, discount) {
        // starting from most expensive
        var sortedItems = this.sortItemsByPrice(cartItems, indices).reverse();
        var item = find(sortedItems, function (item) {
            var discountCountOnItem = 0;
            if (item.discounts) {
                item.discounts.forEach(function (itemDiscount) {
                    if (itemDiscount.id === discount.id) {
                        discountCountOnItem++;
                    }
                });
            }
            if (item && !item.discounts.length || discountCountOnItem < item.quantity) {
                return item;
            }
        });
        return (item) ? item['index'] : -1;
    },
    verifyExclusiveDivisbleOption: function (choices) {
        // if there's 0, can be no other length else , need 1 of each
        var sibKo = { "0": 0, "1": 0, "2": 0 };
        choices.forEach(function (choice) {
            if (choice.siblingId === "0") {
                if (1 < choices.length) {
                    return false;
                }
                else {
                    sibKo[choice.siblingId]++;
                }
            }
            else {
                sibKo[choice.siblingId]++;
            }
        });
        return (sibKo["0"] === 1 && (sibKo["1"] === 0 && sibKo["2"] === 0)) ||
            (sibKo["0"] === 0 && (sibKo["1"] === 1 && sibKo["2"] === 1));
    },
    validateOptions: function (options) {
        var invalidOptions = [];
        invalidOptions = options.filter(function (option) {
            if (option.required && option.choices.length === 0) {
                return true;
            }
            else if (option.choices.length && option.exclusive && option.isDivisible) {
                return !cartService.verifyExclusiveDivisbleOption(option.choices);
            }
        });
        return invalidOptions;
    },
    siblingHasOptions: function (options, siblingId) {
        var siblingOptions = cartService.getSiblingOptions(options, siblingId);
        var choicesSelected = flatMapDeep(siblingOptions);
        return choicesSelected;
    },
    getSiblingOptions: function (options, siblingId) {
        var optionChoices = options.map(function (option) {
            return option.getChoicesForSibling(siblingId);
        });
        return optionChoices;
    },
    getCartTotal: function (cartItems) {
        var total = reduce(cartItems, function (accumulator, item) {
            var itemTotal = 0;
            var bundle = item.bundle;
            if (bundle) {
                itemTotal = bundle.getBundleTotal();
            }
            else {
                itemTotal = item.getItemTotal();
            }
            return accumulator + itemTotal;
        }, 0);
        return total;
    },
    getItemPrice: function (item) {
        return item.getItemTotal();
    },
    compareCartItems: function (itemA, itemB) {
        return (itemA.hash() === itemB.hash());
    },
    initializeCartItems: function (items, locationBase, callback) {
        var mapItems = map(items, function (item) {
            if (item['__mc'] === 'CartItemModel') {
                var cartItem = new CartItemModel(item);
                return cartItem;
            }
            return null;
        });
        var compactItems = compact(mapItems);
        masterStore.dispatch(CART.SET_ITEMS, compactItems);
        // TODO use function once server code is deployed
        // const clonedItems = cloneDeep(compactItems);
        // cartService.getItemPricesFromServer(clonedItems, locationBase, callback);
    },
    splitItemsWithDiscount: function (items) {
        var splitItems = [];
        forEach(items, function (item) {
            item[MARK_REMOVAL_KEY] = false;
            if (item.bundle) {
                return;
            }
            var hasDiscount = item.discounts && (item.discounts.length > 0);
            var discountLength = (hasDiscount) ? item.discounts.length : 0;
            var multipleDiscount = (discountLength >= 1);
            if (item.quantity > 1 && multipleDiscount) {
                var quantity = item.quantity;
                for (var i = 0; i < quantity; i++) {
                    var itemClone = cloneDeep(item);
                    itemClone.quantity = 1;
                    itemClone.invalidatePriceCache();
                    var discounts = [];
                    if (item.discounts.length > 0) {
                        discounts.push(item.discounts.pop());
                    }
                    itemClone.discounts = discounts;
                    splitItems.push(itemClone);
                }
                item[MARK_REMOVAL_KEY] = true;
                item.invalidatePriceCache();
            }
        });
        var remainingItems = filter(items, function (item) {
            return item[MARK_REMOVAL_KEY] === false;
        });
        remainingItems = concat(remainingItems, splitItems);
        forEach(remainingItems, function (item) {
            delete item[MARK_REMOVAL_KEY];
        });
        return remainingItems;
    },
    getItemPricesFromServer: function (originalItems, locationBase, callback) {
        var form = orderService.prepareOrder(originalItems, locationBase);
        var url = "/admin/squib_validate_cart_items?b=" + locationBase;
        var config = {
            withCredentials: true,
        };
        service.post(url, form, config).then(function (result) {
            var data = result.data;
            var body = data && data.body;
            var items = body && body.items;
            if (!items) {
                console.error("Error getting item prices from server.");
                return;
            }
            var validatedItems = cartService.updateCartItemsWithFetchedModels(items);
            callback(validatedItems, originalItems);
            masterStore.dispatch(CART.SET_ITEMS, validatedItems);
        });
    },
    updateCartItemsWithFetchedModels: function (items) {
        var fetchedItems = [];
        var skipItems = {};
        var bundleItems = {};
        forEach(items, function (item, index) {
            if (skipItems[index + 1]) {
                return;
            }
            var fetchedItem;
            if (item.bundle !== null) {
                fetchedItem = recentOrderService.handleBundleRecentOrders(item);
            }
            else {
                fetchedItem = recentOrderService.handleItem(item);
                var siblings = flatMap(item.siblings, 'orig_liid');
                forEach(siblings, function (sibling) {
                    skipItems[sibling] = true;
                });
            }
            fetchedItems.push(fetchedItem);
        });
        // re-index bundle items
        forEach(fetchedItems, function (fetchedItem, index) {
            if (!fetchedItem) {
                return;
            }
            if (fetchedItem.bundle) {
                bundleItems[index] = fetchedItem.bundle.groups.length;
            }
        });
        // merge bundle items back into bundle
        for (var bundleKey in bundleItems) {
            var bundleIndex = +(bundleKey);
            var range = bundleIndex + bundleItems[bundleIndex] + 1;
            var moveItems = fetchedItems.slice(bundleIndex + 1, range);
            var updateItems = function (fetchedItems, checkIndex, checkRange) {
                forEach(fetchedItems, function (fetchedItem, index) {
                    if (index > checkIndex && index < checkRange) {
                        fetchedItem[MARK_REMOVAL_KEY] = true;
                    }
                });
                return fetchedItems;
            };
            updateItems(fetchedItems, bundleIndex, range);
            fetchedItems[bundleIndex].bundle.items = moveItems;
        }
        // clean up
        fetchedItems = compact(fetchedItems);
        var cartItems = [];
        while (fetchedItems.length > 0) {
            var cartItem = fetchedItems.pop();
            // potentially mark cart items without options for removal
            if (cartItem.bundle !== null) {
                if (cartItem.bundle.__mc !== 'BundleModel') {
                    cartItem[MARK_REMOVAL_KEY] = true;
                }
                if (cartItem.bundle.items.length === 0) {
                    cartItem[MARK_REMOVAL_KEY] = true;
                }
                cartItem.bundle.discount = cartItem.discounts[0];
            }
            if (cartItem[MARK_REMOVAL_KEY]) {
                continue;
            }
            cartItems.unshift(cartItem);
        }
        return cartItems;
    },
    calculateOrderTotal: function (totals) {
        var itemTotal = totals.subTotal;
        if (totals.gratuity) {
            itemTotal += totals.gratuity;
        }
        if (totals.discount) {
            itemTotal -= (+totals.discount);
        }
        if (totals.tax) {
            itemTotal += totals.tax;
        }
        return itemTotal;
    }
};
export default cartService;



//////////////////
// WEBPACK FOOTER
// ./src/services/cart.service.ts
// module id = wZ2n
// module chunks = 18